// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"CustomPackagingEdit_tableHeader__3W2GA","addNewButton":"CustomPackagingEdit_addNewButton__2TrOw"};